import React from 'react'
import { CC_ESTEIRA_STEPS, pctDoOrcado } from './budgetDashboardHelpers'
import { BudgetEsteiraBar } from './BudgetEsteiraBar'
import BudgetCardDisponivelBar from './BudgetCardDisponivelBar'

const CARD_BAR_STEPS = CC_ESTEIRA_STEPS.slice(1)

const BudgetCardEsteiraBars = ({ card }) => {
  const orcado = Number(card.orcado || 0)

  return (
    <>
      {CARD_BAR_STEPS.map((step, index) => (
        <BudgetEsteiraBar
          key={step.key}
          etapaLabel={step.label}
          valor={card[step.key]}
          referencia={orcado}
          pct={pctDoOrcado(orcado, card[step.key])}
          className={index < CARD_BAR_STEPS.length - 1 ? 'mb-2' : undefined}
        />
      ))}
      <BudgetCardDisponivelBar card={card} />
    </>
  )
}

export default BudgetCardEsteiraBars
